class MapConfig extends BaseItemConfig {
    metric: KnockoutObservable<number>;

    field: KnockoutObservable<number>;
    fieldAutoGrouping: KnockoutObservable<AutoGroupingEnum>;

    formattingRule: KnockoutObservable<number>;
    source: KnockoutObservable<string>;

    zoomFactor: KnockoutObservable<number>;
    center: KnockoutObservableArray<number>;

    zoomingEnabled: KnockoutObservable<boolean>;
    panningEnabled: KnockoutObservable<boolean>;

    legend: MapLegend;

    attributeName: KnockoutObservable<string>;
    colorization: KnockoutObservable<MapColorizationEnum>;
    startColor: KnockoutObservable<string>;
    endColor: KnockoutObservable<string>;
    gradientRanges: KnockoutObservable<number>;

    constructor(data: any) {
        super(data);

        this.metric = ko.observable(data.metric);

        this.field = ko.observable(data.field);
        this.fieldAutoGrouping = ko.observable(data.fieldAutoGrouping);

        this.formattingRule = ko.observable(data.formattingRule);
        this.source = ko.observable(data.source);

        this.zoomFactor = ko.observable(data.zoomFactor);
        this.center = ko.observableArray(data.center);

        this.zoomingEnabled = ko.observable(data.zoomingEnabled);
        this.panningEnabled = ko.observable(data.panningEnabled);

        this.legend = new MapLegend(data.legend);

        this.attributeName = ko.observable(data.attributeName);
        this.colorization = ko.observable(data.colorization);
        this.startColor = ko.observable(data.startColor);
        this.endColor = ko.observable(data.endColor);
        this.gradientRanges = ko.observable(data.gradientRanges);
    }

    get allowDetailTab(): boolean {
        return true;
    }
}

class MapLegend {
    unitFormat: KnockoutObservable<LabelFormatEnum>;
    decimalPlaces: KnockoutObservable<number>;
    format: KnockoutObservable<FieldFormatEnum>;
    showLegend: KnockoutObservable<boolean>;
    title: KnockoutObservable<string>;

    constructor(data) {
        this.unitFormat = ko.observable(data.unitFormat);
        this.decimalPlaces = ko.observable(data.decimalPlaces);
        this.format = ko.observable(data.format);
        this.showLegend = ko.observable(data.showLegend);
        this.title = ko.observable(data.title);
    }
}

enum MapDataSourceEnum {
    Africa = "dxAfrica",
    Canada = "dxCanada",
    Europe = "dxEurope",
    USA = "dxUSA",
    World = "dxWorld",
    USACities = "USA-Cities",
    IrelandCounties = "Ireland-Counties"
}

enum MapColorizationEnum {
    Gradient = "gradient",
    Range = "range"
}